import { CLASS_CONTROL, CLASS_UNSELECTABLE } from 'ol/css';

import { AbstractLayerControl, AbstractLayerEntry } from './abstract_layer_control';
import { WMSLayer, LEGEND_SIZE_KEY } from '../wms_layer';

import { NAME_KEY, LEGEND_KEY } from '../layer';

import EventType from 'ol/events/EventType';

import { listen } from 'ol/events';
import { unByKey } from 'ol/Observable';

import './legend.css';

class ImageWrapper {
	constructor( image ) {
		this.image = image;
	}
	
	getImage() {
		return this.image;
	}
}

class LegendEntry extends AbstractLayerEntry {
	constructor( layer, parent ) {
		super(layer);
		this.control = parent;
				
		this.listen(this.layer.on("propertychange", ({ key }) => {
			if( key === NAME_KEY || key === LEGEND_KEY || key === LEGEND_SIZE_KEY ) {
				this.updateLegend();
			}
		}));
		
		this.listen(this.layer.on("change:visible", () => this.updateLegend()));
		
		if( this.instance instanceof WMSLayer ) {
			this.listen( this.source.on('change', () => this.updateLegend()));
		}		
		
		
	}
	
	getResolution() {
		return this.control.getMap().getView().getResolution();
	}
	
	hasLegend() {
		return this.instance.hasLegend(this.getResolution());
	}
	
	updateLegend() {
		let url = null;
		
		if( this.instance.isVisible() ) {
			url = this.instance.getLegendUrl(this.getResolution());
		}		
								
		if( url != null && this.element === undefined ) {		
			this.setupElement( url );
			
			const handler = this.instance.getLegendClickHandler();
			if( handler != null ) {
				this.listenKey = listen(this.element, EventType.CLICK, event => {
					handler();
				});	
			}
			
		} else if( url != null && this.element !== undefined ) { 
			this.updateUrl( url );
		} if( !url && this.element !== undefined ) { 
			this.removeElement();
		}  
		
		
	}
	
	updateUrl(url) {
		if( this.timer ) {
			clearTimeout( this.timer );
			this.timer = null;
		}
		
		if( this.label ) {
			this.label.innerText = this.instance.getName() || "";		
		}		
		
		let loader = null;		
		if( this.source && this.source.getImageLoadFunction() ) {		
			loader = this.source.getImageLoadFunction(); 
		} else {
			loader = (img, url) => img.getImage().src = url;
		}
		
		this.timer = setTimeout(() => {
			if( this.imageWrapper ) {
				loader(this.imageWrapper, url);
			}
		}, 250);
	}
	
	setupElement(url) {
		this.element = document.createElement("div");
		this.element.className = "entry";
		
		this.label = document.createElement("div");
		this.label.className = "header";		
		this.label.innerText = this.instance.getName() || "";
		
		this.image = new Image();
		this.imageWrapper = new ImageWrapper(this.image);
		
		this.element.appendChild(this.label);
		this.element.appendChild(this.image);
		
		this.control.element.appendChild(this.element);
		
		this.updateUrl( url );			
	}
	
	removeElement() {
		if( this.element ) {
			this.control.element.removeChild( this.element );
			unByKey(this.listenKey);
			
			this.element = undefined;
			this.label = undefined;
			this.image = undefined;
			this.listenKey = undefined;
		} 
	}
	
	remove() {
		this.removeElement();
		super.remove();
	}
}

class Legend extends AbstractLayerControl {

	constructor( opt_options ) {
		const options = opt_options ? opt_options : {};
	
		super(options);
		
		const className = options.className !== undefined ? options.className : 'ol-legend';
		const containerElement = this.element;
		
		containerElement.className = `${className} ${CLASS_UNSELECTABLE} ${CLASS_CONTROL}`;
		this.handlers = [];
	}
		
	createEntry( layer ) {
		 return new LegendEntry(layer, this);
	}
	
	setMap(map) {
		super.setMap(map);
		
		if( map != null ) {
			map.getView().on("change:resolution", () => this.refresh());		
		}		
	}	
			
	refresh() {						
		this.getLayers()
		.forEach( e => e.updateLegend());		
	}
}

export {
	Legend
}

